import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CloudFunctions {
  private predictSavingsLocalUrl =
    'http://localhost:5000/makaw-3a1bf/europe-west3/predictSavings';
  private predictSavingsUrl =
    'https://europe-west3-makaw-3a1bf.cloudfunctions.net/predictSavings';

  constructor(private http: HttpClient) {}

  public predictSavings(instances: any) {
    const request = {
      instances: [instances],
    };
    return this.http.post(`${this.predictSavingsUrl}`, request);
  }
}
